import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { shallowRef, computed } from 'vue';
import { useAttraqtSearch } from '~/composables/attraqt/useAttraqtIntegration';
import { useSearchFacets } from '~/composables/_next/useSearchFacets';
export function useSearchAdvicesStore() {
  var _useNuxt2App = useNuxt2App(),
    i18n = _useNuxt2App.i18n;
  var adviceFacets = useState('search-facets-advices', function () {
    return null;
  });
  var adviceSorting = useState('search-sorting-advices', function () {
    return null;
  });
  var _useSearchFacets = useSearchFacets(),
    facets = _useSearchFacets.facets;
  var _useAttraqtSearch = useAttraqtSearch('attraqtSearchResults'),
    attraqtResult = _useAttraqtSearch.result,
    attraqtSearch = _useAttraqtSearch.search;
  var route = useRoute();
  var _usePagination = usePagination(),
    currentPage = _usePagination.currentPage;
  var searchData = useState('search-advices', function () {
    return shallowRef(null);
  });

  /**
   * Executes a search for advices with optional category and sorting parameters.
   *
   * @param {string} [category] - Optional category filter.
   * @param {string} [forcedSort] - Optional sorting criteria.
   * @returns {SearchData} The search results.
   */
  function searchAdvices(_x, _x2) {
    return _searchAdvices.apply(this, arguments);
  }
  function _searchAdvices() {
    _searchAdvices = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(category, forcedSort) {
      var _route$params$term;
      var searchFacets, sortLabel, sortFacet;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            searchFacets = Object.entries(facets.value).flatMap(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];
              if (Array.isArray(value) && value.length === 0 || key === 'type') return [];
              return [{
                id: "facet-".concat(key),
                values: value
              }];
            });
            if (category) searchFacets.push({
              id: 'facet-category',
              values: [category]
            });
            sortLabel = forcedSort !== null && forcedSort !== void 0 ? forcedSort : Array.isArray(route.query.sort) ? route.query.sort[0] : route.query.sort;
            sortFacet = getSortCriteria(sortLabel);
            adviceSorting.value = getAdviceSorting(sortLabel);
            _context.next = 7;
            return attraqtSearch({
              query: (_route$params$term = route.params.term) !== null && _route$params$term !== void 0 ? _route$params$term : '',
              options: {
                limit: 18,
                offset: (currentPage.value - 1) * 18,
                filter: "kind=article",
                facets: searchFacets,
                sortBy: [sortFacet]
              }
            });
          case 7:
            // Object.assign is required here to change the reference of the object for reactivity purposes.
            searchData.value = Object.assign({}, attraqtResult.value);
            adviceFacets.value = getAdviceFacets(searchData.value);
            return _context.abrupt("return", searchData.value);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _searchAdvices.apply(this, arguments);
  }
  var advices = computed(function () {
    var _searchData$value$dat, _searchData$value, _searchData$value$dat2;
    return (_searchData$value$dat = (_searchData$value = searchData.value) === null || _searchData$value === void 0 ? void 0 : (_searchData$value$dat2 = _searchData$value.data) === null || _searchData$value$dat2 === void 0 ? void 0 : _searchData$value$dat2.items.map(function (item) {
      return item.product;
    })) !== null && _searchData$value$dat !== void 0 ? _searchData$value$dat : [];
  });
  var advicePagination = computed(function () {
    var _searchData$value2, _searchData$value2$da;
    var searchMeta = (_searchData$value2 = searchData.value) === null || _searchData$value2 === void 0 ? void 0 : (_searchData$value2$da = _searchData$value2.data) === null || _searchData$value2$da === void 0 ? void 0 : _searchData$value2$da.metadata;
    if (!searchMeta) return null;
    return {
      count: searchMeta.count,
      pages: Math.ceil(searchMeta.count / searchMeta.limit),
      current: currentPage.value
    };
  });
  var sortingOptions = [{
    type: 'sort',
    id: 'pertinence',
    value: 'sort.pertinence',
    sortCriteria: {}
  }, {
    type: 'sort',
    id: 'latest',
    value: 'sort.latest',
    sortCriteria: {
      attribute: 'ctfCreatedAt',
      order: 'asc'
    }
  }, {
    type: 'sort',
    id: 'oldest',
    value: 'sort.oldest',
    sortCriteria: {
      attribute: 'ctfCreatedAt',
      order: 'desc'
    }
  }, {
    type: 'sort',
    id: 'alphabeticalAscending',
    value: 'sort.nameAsc',
    sortCriteria: {
      attribute: 'title',
      order: 'asc'
    }
  }, {
    type: 'sort',
    id: 'alphabeticalDescending',
    value: 'sort.nameDesc',
    sortCriteria: {
      attribute: 'title',
      order: 'desc'
    }
  }];

  /**
   * Retrieves the sorting criteria based on the provided sort type.
   *
   * @param {string} sort - The sorting type.
   * @returns {Object} The sorting criteria.
   */
  function getSortCriteria(sort) {
    var _sortingOptions$find$, _sortingOptions$find;
    var DEFAULT_SORT_CRITERIA = sortingOptions[0].sortCriteria;
    return (_sortingOptions$find$ = (_sortingOptions$find = sortingOptions.find(function (option) {
      return option.id === sort;
    })) === null || _sortingOptions$find === void 0 ? void 0 : _sortingOptions$find.sortCriteria) !== null && _sortingOptions$find$ !== void 0 ? _sortingOptions$find$ : DEFAULT_SORT_CRITERIA;
  }

  /**
   * Retrieves the selected sorting option for advices.
   *
   * @param {string} sort - The sorting type.
   * @returns {Object} The sorting configuration for advices.
   */
  function getAdviceSorting(sort) {
    return {
      options: [].concat(sortingOptions),
      selected: sort !== null && sort !== void 0 ? sort : 'pertinence'
    };
  }

  /**
   * Computes available facets based on the `articleListing` data.
   *
   * @param {SearchData} adviceListing - The article listing.
   * @returns {Facet[]} The available article facets.
   */
  function getAdviceFacets(adviceListing) {
    var _adviceListing$data, _adviceListing$data$m;
    var facets = adviceListing === null || adviceListing === void 0 ? void 0 : (_adviceListing$data = adviceListing.data) === null || _adviceListing$data === void 0 ? void 0 : (_adviceListing$data$m = _adviceListing$data.metadata) === null || _adviceListing$data$m === void 0 ? void 0 : _adviceListing$data$m.facets.flatMap(function (facet) {
      var _facet$values, _facet$values2;
      if (!((_facet$values = facet.values) !== null && _facet$values !== void 0 && _facet$values.length)) return [];
      return [{
        id: facet.attribute,
        label: i18n.t("search.filters.".concat(facet.attribute)),
        options: (_facet$values2 = facet.values) === null || _facet$values2 === void 0 ? void 0 : _facet$values2.map(function (value) {
          return {
            count: value.count,
            id: value.value
          };
        })
      }];
    });
    return [facets === null || facets === void 0 ? void 0 : facets.find(function (facet) {
      return facet.id === 'category';
    })];
  }
  return {
    adviceSorting: adviceSorting,
    adviceFacets: adviceFacets,
    searchAdvices: searchAdvices,
    advices: advices,
    advicePagination: advicePagination
  };
}